import {useState} from 'react';

import {ConsultProtocolsItem} from 'domain/usecases';

export function useProtocols() {
	const [openDrawerState, setOpenDrawerState] = useState(false);
	const [protocolSelectedState, setProtocolSelectedState] = useState<ConsultProtocolsItem | null>(
		null,
	);

	const onOpenDrawer = () => {
		setOpenDrawerState(true);
	};

	const onCloseDrawer = () => {
		setOpenDrawerState(false);
	};

	const handleViewMore = (protocol: ConsultProtocolsItem) => {
		setProtocolSelectedState(protocol);
		onOpenDrawer();
	};

	return {
		openDrawerState,
		protocolSelectedState,
		onOpenDrawer,
		onCloseDrawer,
		handleViewMore,
	};
}
